// extracted by mini-css-extract-plugin
export default {"form":"form__S0yEmR","row":"row__wihtwY","btnSave":"btnSave__EbKCRt"};